import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-void flex items-center justify-center px-5 noise-mask" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#222] bg-matte">
        <div className="p-8 border-b border-[#222] flex items-center gap-3">
          <img src="/vp-logo-neon.png" alt="Vice Performance" className="h-10 w-auto" />
          <div>
            <div className="font-display uppercase text-2xl tracking-tight leading-none">Vice Admin</div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mt-1">Command Center</div>
          </div>
        </div>
        <form onSubmit={submit} className="p-8 space-y-5" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mb-2">Email</span>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-void border border-[#222] px-4 py-3 font-mono text-sm outline-none focus:border-neon focus:ring-1 focus:ring-neon rounded-none"
              placeholder="admin@viceperformance.com"
            />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.2em] text-[#9CA3AF] mb-2">Password</span>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-void border border-[#222] px-4 py-3 font-mono text-sm outline-none focus:border-neon focus:ring-1 focus:ring-neon rounded-none"
              placeholder="••••••••"
            />
          </label>
          {error && <div data-testid="login-error" className="text-sm font-mono text-red-400 border border-red-900 bg-red-950/40 px-4 py-3">{error}</div>}
          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-neon text-void font-bold uppercase tracking-[0.2em] text-sm py-4 flex items-center justify-center gap-2 hover:bg-[#FAFAFA] transition-colors disabled:opacity-50"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
